import React from "react";
import { connect, ConnectedProps } from "react-redux";
import styled from "styled-components";
import { fadeIn } from "sweet-web/lib/animations";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import BudgetFilter from "./BudgetFilter";
import DateFilter from "./DateFilter";
import EventTypeFilter from "./EventTypeFilter";
import GuestsFilter from "./GuestsFilter";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: fixed;
  top: 60px;
  left: 0px;
  right: 0px;
  padding: 10px 60px 10px 60px;
  background-color: ${colors.white};
  z-index: 30;
  ${fadeIn}
  @media screen and (max-width: 600px) {
    justify-content: center;
    flex-wrap: wrap;
    left: 0;
    right: 0;
    padding: 0 20px 5px 20px;
    border-bottom: 1px solid ${colors.lightGray};
  }
`;

const Divider = styled.div`
  height: 100%;
  width: 3px;
  background-color: ${colors.white};
  &:last-of-type {
    display: none;
  }
`;

const BORDER_RADIUS = 5;

type Props = ConnectedProps<typeof connector>;

const Filters: React.FC<Props> = props => {
  const FilterComponents = [GuestsFilter, BudgetFilter, DateFilter];

  if (props.eventType) FilterComponents.push(EventTypeFilter);

  return (
    <Wrapper>
      {FilterComponents.map((Filter, i) => (
        <React.Fragment key={`filter-${i}`}>
          {React.createElement(Filter, {
            style:
              i === 0
                ? {
                    borderTopLeftRadius: BORDER_RADIUS,
                    borderBottomLeftRadius: BORDER_RADIUS
                  }
                : i === FilterComponents.length - 1
                ? {
                    borderTopRightRadius: BORDER_RADIUS,
                    borderBottomRightRadius: BORDER_RADIUS
                  }
                : {}
          })}
          <Divider />
        </React.Fragment>
      ))}
    </Wrapper>
  );
};

const mapState = (state: RootState) => ({
  eventType: selectors.searchFilter("eventType")(state)
});
const connector = connect(mapState);

export default connector(Filters);
